import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useEffect, useState } from 'react';
import Scroll from 'react-scroll';
import utilsRests from '../../../MyConns/_Utils/utilsRests';

var scroller = Scroll.scroller;

const BuisSelectFromList = (props) => {

    const [contentList, setContentList] = useState([]);
    const [tempCont, setTempCont] = useState([]);
    const [loading, setLoading] = useState(true);
    const [theCheks, setTheCheks] = useState(props.chsksList ? props.chsksList : []);
    const [displyList, setDisplyList] = useState();
    const [thePopUp, setThePopUp] = useState("");
    const [searchTxt, setSearchTxt] = useState("");



    useEffect(() => {
        getAllRests();
        console.log(props.chsksList)
    }, [])

    useEffect(() => {
        setTheDisplay();
    }, [tempCont, theCheks])


    const getAllRests = async () => {
        let restsList = await utilsRests.getRestsListSmall();

        setContentList(restsList);
        setTempCont(restsList);
        setLoading(false);
    }


    const setChkCat = (item, checkOrNot) => {

        let tempCats = [...theCheks];
        if (!checkOrNot) {
            let bk = tempCats.findIndex(el => el._id === item._id);

            if (bk != -1) {
                tempCats.splice(bk, 1);
            }
        }
        else {
            tempCats.push(item);
        }

        setTheCheks(tempCats)


    }

    const setTheDisplay = () => {

        let counter = 0;
        let bk = tempCont.map((item, index) => {

            let chck = (theCheks.findIndex(el => el._id == item._id) != -1) ? true : false;

            counter++;

            return (
                <div key={index} className={"col-md-6"}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={chck}
                                onChange={() => setChkCat(item, !chck)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                className={"blackCheck"}
                            />
                        }
                        label={item.buissName}
                    />

                </div>

            )
        })
        setDisplyList(bk);
    }


    const serachTheBuis = (e) => {
        let tempo = [...contentList];
        setTempCont(tempo.filter(itm => itm.buissName.startsWith(e.target.value)));
        setSearchTxt(e.target.value);
        setTheDisplay();
    }

    return (
        <>
            {loading ? "Loading" :
                <>
                    <div className={"PopTopLine"}>
                        <input type={"text"} placeholder={"חפש שם עסק"} value={searchTxt} onChange={(e) => serachTheBuis(e)} className={"buisSearchTxt"} />
                    </div>
                    <div className="popSelectImgBox">
                        {displyList}
                    </div>
                    <div className="bottomBtnsline">
                        <button type="button" className="onLeft btn btn-success btn-primary" onClick={() => props.setTheList(theCheks)}>שמור</button>
                        <button type="button" className="onLeft btn btn-primary" onClick={() => props.handleClose()}>סגור</button>
                    </div>

                </>
            }
            {thePopUp}
        </>
    );
}

export default BuisSelectFromList;